import Button from 'components/Button';
import Icon from 'components/Icon';
import * as theme from 'theme';

const AddButton = props => (
  <Button theme="square" style={{ background: theme.colors.green }} {...props} children={<Icon type="plus" />} />
);

export default AddButton;
